import { UserPlus, Users, Briefcase, DoorOpen, Flag } from 'lucide-react'
import LoopPage from '../../components/LoopPage'
import { WAITLIST_CTA_TEXT, VOE_WAITLIST_HREF } from '../../config/cta'

const stakeholders = [
  { icon: UserPlus, label: 'New hires', description: 'The 90-day window. What surprised them. What the recruiting story missed.' },
  { icon: Users, label: 'Tenured employees', description: 'The people who have seen multiple cycles. The novel perspective on what is shifting, working, or breaking.' },
  { icon: Briefcase, label: 'Managers', description: 'The layer where rollouts succeed or stall. What they are absorbing on behalf of their teams.' },
  { icon: DoorOpen, label: 'Departing employees', description: 'Exit interviews that surface the truth, not the script.' },
  { icon: Flag, label: 'ERG members', description: 'Community-level signal on belonging, equity, and the gap between policy and lived experience.' },
]

export default function EmployeeLoop() {
  return (
    <LoopPage
      h1="The conversations your engagement survey can't have."
      subhead="Onboarding retros, rollout retros, exit interviews, culture deep-dives. Real conversations that surface what surveys flatten."
      outerLoopSteps={['Hire', 'Engage', 'Develop', 'Retain']}
      gapHeadline="Annual engagement scores are too late and too coarse."
      gapBody="Engagement surveys hit once a year. Pulse surveys get gamed. Skip-levels are filtered through politeness. The novel perspective on why the rollout stalled never surfaces. PrismScope runs conversations where employees can be honest and where the patterns become visible across the org."
      stakeholders={stakeholders}
      sampleRetro={{
        wentWell: 'Onboarding 90-day cohort articulated value of the buddy program. Manager listening sessions surfaced two systemic blockers.',
        couldHaveBeenBetter: 'Rollout adoption variable across regions. Exit interview themes around career pathing concentrated in one function.',
        whatsNext: 'Adjust rollout cadence for the lagging region. Build a career-pathing review in the function with concentrated exit signal.',
      }}
      calloutBlock={{
        kind: 'comingSoon',
        headline: 'Voice of Employee — coming soon.',
        body: 'A dedicated product for continuous employee listening, built on the same conversational engine. Join the waitlist to be notified at launch.',
        ctaText: WAITLIST_CTA_TEXT,
        ctaHref: VOE_WAITLIST_HREF,
      }}
      trackingPrefix="employee-loop"
      seoTitle="Employee Engagement & Voice of Employee Feedback"
      seoDescription="Onboarding retros, rollout retros, exit interviews, and culture deep-dives. Real conversations that surface what annual engagement surveys flatten."
      seoPath="/feedback-loops/employee"
    />
  )
}
